import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { validateEmail } from "../../utils/util";
import { searchUsers } from "../../services/users";
import { Login } from "../../actions/actions";
import PageSelector from '../../components/PageSelector';
import LoadingPage from "../../components/Loading";
import DropdownMenu from '../../components/DropdownMenu'
import { fetchEvents, insertEvent } from "../../services/events";
import SearchSvg from '../../svgs/SearchSvg';

const limit = 20
function Page(props) {
    const navigate = useNavigate();
    const location = useLocation();
    const navigateTo=(str)=>()=>{
        navigate(str)
    }
    const [isloading,setIsloading]=useState(false)
 

    const [searchParams, setSearchParams] = useSearchParams();
    const [totalItem, setTotalItem] = useState(1)
    const totalPage = Math.ceil(totalItem/limit)||1
    const [data,setData]=useState([])
    const page =  parseInt(searchParams.get('page'))||1
    const filterName = searchParams.get('name')
    const filterType = searchParams.get('type')||'全部'
    //
    const handleSearchName=(e)=>{setSearchParams({page:1,name:e.target.value})}
    useEffect(() => {
        if(!props.token.isLogin)return
        const timer = setTimeout(fetchData, 500)
        const interval = setInterval(fetchData,1000*30)
        return () => {
            clearTimeout(timer)
            clearInterval(interval)
        }
    },[searchParams,props.token])
    async function fetchData(){
        const filter = {}
        if(filterType !== '全部') filter['status'] = filterType==='草稿'?'draft':'published'
 
        if(filterName) filter['name'] = {"$regex": filterName, "$options":'i'}
        const res = await fetchEvents(filter, {limit,skip:limit*(page-1),sort:{order:-1}})
        if(res.errno) return
        setTotalItem(res.count)
        setData(res.result)

        const toPage = Math.ceil(res.count/limit) || 1
        if(page > toPage) handleParamChange('page', 1)
    }
    const handleSelectPage=(p)=>()=>{
        if(p > totalPage || p < 1) return;
        searchParams.delete('page')
        searchParams.set('page', p)
        setSearchParams(searchParams)
    }
    function handleParamChange(key, val){
        searchParams.delete(key)
        if(val !== '') searchParams.set(key, val)
        setSearchParams(searchParams)
    }
    function selectFilter(item,index){
        searchParams.delete('type')
        searchParams.set('type', item)
        setSearchParams(searchParams)
    }

    //new event
    const [isAddingNewEvent, setIsAddingNewEvent] = useState(false)
    const handleAddEvent=async ()=>{
        if(isAddingNewEvent?.name?.length<3){
            alert('活動名稱長度需大於3')
            return
        }
        setIsloading(true)
        let json ={
            name:isAddingNewEvent?.name,
            status:'draft',
            isRecommended:false,
            subtitle:'',
            time:'',
            date:'',
            preview:null,
            location:'',
            order:99,
            isRequireApproval:true,
            isScannable:false,
            isParticipationDisabled:true,
            introduction:[],
            promotions:[],
        }
        let result = await insertEvent(props.token.token,json)
        if(result.errno){
            alert(result.message||'新增活動失敗')
        }else{
            alert('新增活動成功')
            setIsAddingNewEvent(false)
            handleParamChange('page', 1)
        }
        setIsloading(false)
    }
    return(
        <div className="h-full flex flex-col items-center justify-start bg-[#ddd] overflow-hidden pb-[16px]" style={{}}>
            <div className="w-full flex flex-row gap-[16px] items-center justify-between relative p-[16px]">
                <div className="gap-[8px] flex flex-row items-center justify-start z-[2] px-[12px] py-[2px] border-[1px] border-[#6E604C] rounded-[99px]">
                    <SearchSvg />
                    <input onChange={handleSearchName} placeholder="按活動名稱搜尋" className="bg-[transparent] w-[130px] border-none" />
                </div>
                <div className="z-[2] flex flex-row gap-[16px]">
                    <div className="text-[#6E604C]">Filter By </div>
                    <DropdownMenu value={filterType} select={selectFilter} options={['全部', '草稿', '已公開']} />
                </div>
                <div className="flex flex-row flex-1 justify-end gap-[16px] z-[2]">
                    <div onClick={()=>{setIsAddingNewEvent({})}} className="cursor-pointer hover:opacity-80">
                        <NewActivityButton/>
                    </div>
                </div>
                <div className="absolute top-0 left-0 right-0 bottom-0 z-[1]" style={{background:'linear-gradient(180deg, rgba(230, 235, 237, 0.3) 28.5%, #FFFFFF 100%)'}}/>
            </div>
            <div className="flex-1 w-full flex flex-col py-[16px] justify-start items-stretch px-[8px]" style={{overflow:'auto'}}>
                {/*Header */}
                <div className="flex flex-row justify-betwen items-center min-w-full text-[12px] text-[#6E604C] font-[700] pb-[8px]" style={{borderBottom:'2px solid #6E604C'}}>
                    <div className="min-w-[100px] w-[100px] mr-[8px]"></div>
                    <div className="flex-[2] min-w-[200px]">活動名稱</div>
                    <div className="flex-[1] min-w-[50px]">狀態</div>
                    <div className="flex-[1] min-w-[100px]">總參與人數</div>
                    <div className="flex-[2] min-w-[100px]">創建時間</div>
                    <div className="flex-[2] min-w-[100px]">更新時間</div>
                    <div className="flex-[2] min-w-[100px]">日期</div>
                    <div className="flex-[2] min-w-[100px]">地點</div>
                    <div className="flex-[1] min-w-[70px]">顯示順序</div>
                    <div className="min-w-[300px] w-[300px]">操作</div>
                </div>

                <div className="flex-1 w-full flex flex-col mt-[16px]">
                    {data?.map((item,index)=>
                        <div key={item?._id} className="flex flex-row justify-betwen items-center min-w-full text-[12px] text-[black] font-[400] py-[8px]" style={{borderBottom:'.5px solid #fff'}}>
                            <div className="min-w-[100px] w-[100px] mr-[8px]">
                                {item?.preview?<img src={item?.preview} className="w-[100%] h-[100px] rounded-[8px]  object-cover" alt="preview"/>:<div className="w-[100%] h-[100px] rounded-[8px] bg-[#ddd]"></div>}
                            </div>
                            <div className="flex-[2] min-w-[200px]">{item?.name||''}</div>        
                            <div className="flex-[1] min-w-[50px]">{item?.status==='published'?'已公開':'草稿'}</div>    
                            <div className="flex-[1] min-w-[100px]">{item?.participationsCounts||0}</div>
                            <div className="flex-[2] min-w-[100px]">{new Date(item?.createDate).toLocaleString()}</div>     
                            <div className="flex-[2] min-w-[100px]">{new Date(item?.modifyDate).toLocaleString()}</div> 
                            <div className="flex-[2] min-w-[100px]">{item?.date}</div>
                            <div className="flex-[2] min-w-[100px]">{item?.location}</div>
                            <div className="flex-[1] min-w-[70px]">{item?.order||'-'}</div>
                            <div className="min-w-[300px] w-[300px] flex flex-row items-start justify-start">
                                <div onClick={navigateTo(`/cms/events/${item?._id}`)} className="w-[90px] text-center cursor-pointer border-[#6E604C]  border-[1px] text-[#6E604C] p-[2px] rounded-[4px] bg-[#6E604C30]">報名數據</div>
                            </div>
                        </div>
                    )}
                </div>

            </div>

         
            <PageSelector page={page} total={totalItem} totalPage={totalPage} handleSelectPage={handleSelectPage}/>
            
            {isAddingNewEvent&&<div className="fixed top-0 left-0 w-full h-full bg-[#00000099] flex flex-col items-center justify-center z-[1]">
                <div className="max-w-[90%] max-h-[90%] min-w-[500px] bg-[#fff] rounded-[8px] flex flex-col items-center justify-start p-[16px]">
                    <div className="font-bold text-[24px] w-full text-center">新活動</div>
                    <div className="flex flex-col items-start justify-start w-full mt-[16px] w-[370px] max-w-[100%]">
                        <div className='font-[700]'>活動名稱</div>
                        <input value={isAddingNewEvent?.name||''} onChange={(e) => { setIsAddingNewEvent({ ...data, name: e.target.value }) }} placeholder='活動名稱' className='w-full rounded-[7px] px-[8px] py-[4px] font-[400]' style={{border:'.5px solid black'}}/>
                    </div>
                    <div className="flex flex-col items-center justify-center w-full mt-[64px] gap-[16px]">
                        <div onClick={handleAddEvent} className="cursor-pointer text-[white] justify-center bg-[#0F737E] w-full rounded-[99px] text-[14px] font-[700] p-[8px] hover:opacity-80 items-center flex flex-row">
                            添加
                        </div>
                        <div onClick={()=>{setIsAddingNewEvent(false)}} className="cursor-pointer justify-center text-[#0F737E] w-full rounded-[99px] text-[14px] font-[700] p-[8px] rounded-[4px] bg-[#eee] hover:opacity-80 items-center flex flex-row">
                            取消
                        </div>
                    </div>
                </div>
            </div>}
            {isloading&&<LoadingPage/>}
        </div>
    )
}


export default connect((store)=>{
    return{
      token:store.tokenReducer,
      control:store.controlReducer,
    }
  })(Page)


  const NewActivityButton = (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={186}
      height={40}
      fill="none"
      {...props}
    >
      <rect width={186} height={40} fill="url(#aasas)" rx={7} />
      <g clipPath="url(#basas)">
        <path
          fill="#fff"
          d="M69.25 20.75h-4.5v4.5h-1.5v-4.5h-4.5v-1.5h4.5v-4.5h1.5v4.5h4.5v1.5Z"
        />
      </g>
      <path
        fill="#fff"
        d="M84.52 17.696h5.984v1.776H84.52v-1.776ZM75.848 14h7.216v1.552h-7.216V14Zm-.144 6.368h7.344v1.616h-7.344v-1.616Zm-.048-2.8h7.536v1.568h-7.536v-1.568Zm11.456.912h1.872v8.88h-1.872v-8.88Zm-8.576-5.936h1.856v2.144h-1.856v-2.144Zm0 6.496h1.856v8.368h-1.856V19.04Zm5.12-5.376 2.24.64c-.01.139-.144.23-.4.272v4.704c0 .597-.032 1.253-.096 1.968a14.77 14.77 0 0 1-.336 2.176c-.17.736-.421 1.45-.752 2.144A7.403 7.403 0 0 1 83 27.472a1.926 1.926 0 0 0-.368-.48 7.53 7.53 0 0 0-.512-.496 2.147 2.147 0 0 0-.496-.336c.47-.49.837-1.019 1.104-1.584.277-.576.48-1.168.608-1.776.139-.608.224-1.21.256-1.808.043-.608.064-1.19.064-1.744v-5.584Zm5.232-1.088 1.536 1.392c-.544.245-1.136.47-1.776.672-.64.203-1.296.384-1.968.544-.661.15-1.301.283-1.92.4a6.189 6.189 0 0 0-.256-.736 5.053 5.053 0 0 0-.352-.72 37.775 37.775 0 0 0 1.744-.432c.587-.17 1.136-.352 1.648-.544.523-.192.97-.384 1.344-.576Zm-8.624 9.472c.117.064.288.181.512.352.235.17.48.357.736.56.256.192.485.373.688.544.213.16.373.277.48.352l-1.12 1.376a14.81 14.81 0 0 0-.496-.544 9.284 9.284 0 0 0-.64-.672 36.004 36.004 0 0 0-.656-.64 14.81 14.81 0 0 0-.544-.496l1.04-.832Zm-3.616-6.256 1.488-.352c.139.288.261.613.368.976.107.352.176.656.208.912l-1.552.432a5.476 5.476 0 0 0-.176-.944 5.485 5.485 0 0 0-.336-1.024Zm3.984-.384 1.712.336c-.15.363-.293.715-.432 1.056-.139.33-.267.613-.384.848l-1.536-.32c.075-.181.155-.384.24-.608.085-.224.165-.448.24-.672.075-.235.128-.448.16-.64Zm-2.08 5.888 1.344.512a13.985 13.985 0 0 1-2.112 3.36 9.476 9.476 0 0 1-1.28 1.264 6.517 6.517 0 0 0-.576-.704 5.393 5.393 0 0 0-.672-.656 7.963 7.963 0 0 0 1.248-1.008c.416-.416.8-.859 1.152-1.328.363-.48.661-.96.896-1.44Zm18.72-.352h8.4v6.4h-1.84v-4.656h-4.8v4.736h-1.76v-6.48Zm7.12-8.544 1.472 1.504a20.24 20.24 0 0 1-2.592.784c-.949.213-1.925.39-2.928.528a59.48 59.48 0 0 1-2.912.336 4.166 4.166 0 0 0-.224-.816 5.93 5.93 0 0 0-.32-.816c.683-.075 1.37-.16 2.064-.256a37.254 37.254 0 0 0 2.048-.336c.661-.128 1.28-.267 1.856-.416a14.37 14.37 0 0 0 1.536-.512Zm-3.84 1.808h1.824v7.744h-1.824v-7.744Zm-4.272 2.864h10.192v1.824H96.28v-1.824Zm2.256 7.952h6.064v1.744h-6.064v-1.744ZM92.328 14l1.088-1.392c.299.15.635.32 1.008.512s.736.384 1.088.576c.363.192.656.363.88.512l-1.136 1.552a9.514 9.514 0 0 0-.832-.544 73.9 73.9 0 0 0-1.072-.624A32.96 32.96 0 0 0 92.328 14Zm-.768 4.432 1.04-1.424c.299.128.64.288 1.024.48s.757.384 1.12.576c.363.181.656.347.88.496l-1.072 1.6a8.6 8.6 0 0 0-.848-.544c-.341-.203-.704-.41-1.088-.624-.384-.213-.736-.4-1.056-.56Zm.24 7.52c.288-.405.603-.88.944-1.424.352-.555.71-1.141 1.072-1.76.363-.63.704-1.253 1.024-1.872l1.408 1.28a54.113 54.113 0 0 1-.896 1.712c-.31.587-.63 1.163-.96 1.728-.32.565-.645 1.11-.976 1.632L91.8 25.952Zm16.128-3.2h7.472v1.36h-7.472v-1.36Zm-.352-7.616h8v1.392h-8v-1.392Zm3.168-1.12h1.744v11.472h-1.744V14.016Zm-3.264 11.28c.672-.043 1.44-.096 2.304-.16.864-.064 1.776-.133 2.736-.208.971-.085 1.936-.17 2.896-.256l.016 1.456c-.907.096-1.824.192-2.752.288-.917.096-1.803.181-2.656.256-.843.085-1.616.165-2.32.24l-.224-1.616Zm2.032-5.088v.72h4.224v-.72h-4.224Zm0-1.856v.72h4.224v-.72h-4.224Zm-1.52-1.2h7.328v4.976h-7.328v-4.976Zm6.56-4.656.832 1.424a29.89 29.89 0 0 1-2.272.368c-.832.096-1.685.176-2.56.24-.875.053-1.712.09-2.512.112a4.395 4.395 0 0 0-.176-.688 3.92 3.92 0 0 0-.256-.688c.597-.032 1.211-.07 1.84-.112a91.694 91.694 0 0 0 1.856-.176c.619-.064 1.2-.133 1.744-.208a26.27 26.27 0 0 0 1.504-.272Zm1.008 3.536h5.552v1.76h-5.552v-1.76Zm4.768 0h1.84V16.88c-.043 1.643-.085 3.04-.128 4.192a88.306 88.306 0 0 1-.144 2.832c-.043.736-.112 1.312-.208 1.728-.085.416-.192.715-.32.896-.181.267-.373.453-.576.56a2.097 2.097 0 0 1-.688.256 5.326 5.326 0 0 1-.896.064c-.352.01-.72.01-1.104 0a3.782 3.782 0 0 0-.176-.928 3.795 3.795 0 0 0-.368-.912 19.145 19.145 0 0 0 1.6.08.711.711 0 0 0 .32-.064.724.724 0 0 0 .24-.208c.085-.128.16-.373.224-.736.064-.373.117-.901.16-1.584a59.12 59.12 0 0 0 .128-2.672c.043-1.088.075-2.405.096-3.952v-.4Zm-3.232-3.36h1.84c0 1.365-.016 2.661-.048 3.888a38.718 38.718 0 0 1-.208 3.472 16.923 16.923 0 0 1-.56 3.008 9.689 9.689 0 0 1-1.088 2.512 7.639 7.639 0 0 1-1.808 2 3.546 3.546 0 0 0-.384-.512 7.255 7.255 0 0 0-.48-.528 3.18 3.18 0 0 0-.48-.4 6.691 6.691 0 0 0 1.632-1.76 8.5 8.5 0 0 0 .96-2.224c.224-.821.379-1.717.464-2.688.085-.981.133-2.032.144-3.152.011-1.13.016-2.336.016-3.616Z"
      />
      <defs>
        <linearGradient
          id="aasas"
          x1={93}
          x2={93}
          y1={0}
          y2={40}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8C866B" />
          <stop offset={1} stopColor="#8C866B" stopOpacity={0.2} />
        </linearGradient>
        <clipPath id="basas">
          <path fill="#fff" d="M55 11h18v18H55z" />
        </clipPath>
      </defs>
    </svg>
  )
